import { Entity, Field } from '@adornis/baseql/decorators.js';
import type { PartialEntityData } from '@adornis/baseql/entities/types.js';
import { AdornisFilter } from '@adornis/filter/AdornisFilter.js';
import type { CampusArea } from '../campus-learning-content/entities/CampusSection.js';

@Entity()
export class CampusLessonFilter extends AdornisFilter {
  public static override _class = 'CampusLessonFilter';

  constructor(doc: PartialEntityData<CampusLessonFilter>) {
    super(doc);
  }

  @Field(() => String)
  public sectionArea?: CampusArea;

  @Field(() => Boolean)
  public onlyPublishedLessons?: boolean;

  override getMongoFilter(): Record<string, any> {
    const filter = super.getMongoFilter();
    return { ...filter, ...(this.onlyPublishedLessons ? { hiddenFromStudents: { $ne: true } } : {}) };
  }
}
